import Page from "../../components/Page";
import ProfileReportHomeSection from "../../components/Reports/profileCompletion/ProfileReportHomeSection";
import Loader from "../../components/Loader/Loader";
import { useEffect, useState } from "react";

export const ProfileCompletionReportPage = () => {
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])
    return (
        <>
        <Loader start={isLoading} />
        <Page>
            <ProfileReportHomeSection 
            setIsLoading = {setIsLoading}
            isLoading={isLoading}
            />
        </Page>
        </>
    )
}

export default ProfileCompletionReportPage;